import { type File, type Report, useStores } from '@littlebird/sdk';

import { filePreviewPanelStore } from '@/features/chat/file-preview-panel.store';
import { useTabs } from '@/features/tabs';

import { chooseReportArtifact } from '../report-body';

export const useOpenRoutineArtifact = (report: Report) => {
  const { openTab } = useTabs();
  const { files } = useStores();

  return (file: File) => {
    const main = chooseReportArtifact(
      report.artifactFileIds.map((id) => files.getById(id))
    );
    const isMainCanvas = !!main?.isCanvas && main.file?.id === file.id;

    if (report.chatId && !isMainCanvas)
      filePreviewPanelStore.open(report.chatId, file.id);
    if (isMainCanvas && filePreviewPanelStore.threadId === report.chatId)
      filePreviewPanelStore.close();

    openTab(
      {
        path: `/routines/${report.reportTemplateId}`,
        search: isMainCanvas
          ? { view: 'canvas', run: report.referenceId }
          : { run: report.referenceId },
      },
      { reuseExisting: true }
    );
  };
};
